import { FormEvent, useState } from "react";
import { supabase } from "../lib/supabase";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import { Card } from "../ui/Card";
import { Icon } from "../ui/icons";
import { t } from "../i18n";

export function Login() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: { emailRedirectTo: window.location.origin, shouldCreateUser: false },
      });
      if (error) {
        const noAccount = /signups? not allowed/i.test(error.message);
        setError(
          noAccount
            ? `${t("login.inviteNeededEn")}\n${t("login.inviteNeededHe")}`
            : error.message,
        );
        return;
      }
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--space-4)",
        background: "var(--paper)",
      }}
    >
      <div style={{ width: "100%", maxWidth: 400 }}>
        {/* Brand wordmark */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 24,
            justifyContent: "center",
          }}
        >
          <div className="sidebar-brand-mark" style={{ width: 36, height: 36, borderRadius: 10 }}>
            <Icon name="audio" size={18} />
          </div>
          <span className="sidebar-brand-name" style={{ fontSize: 18 }}>
            Timlul{" "}
            <span className="sidebar-brand-he">· תמלול</span>
          </span>
        </div>

        <Card>
          {sent ? (
            <div
              style={{
                textAlign: "center",
                padding: "var(--space-4) 0",
                color: "var(--ink-2)",
              }}
            >
              <Icon name="inbox" size={32} style={{ color: "var(--accent)", display: "block", margin: "0 auto 12px" }} />
              <h2 style={{ margin: "0 0 8px", fontSize: 18 }}>{t("login.checkInbox")}</h2>
              <p style={{ margin: 0, fontSize: 14, color: "var(--ink-3)" }}>
                {t("login.checkInboxDetail")} <strong>{email}</strong>.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <h2 style={{ margin: "0 0 4px", fontSize: 18 }}>{t("login.signIn")}</h2>
              <p style={{ margin: "0 0 20px", fontSize: 13, color: "var(--ink-3)" }}>
                {t("login.tagline")}
              </p>

              <div style={{ marginBottom: 12 }}>
                <label
                  htmlFor="email"
                  style={{ display: "block", marginBottom: 4, fontSize: 13, fontWeight: 600 }}
                >
                  {t("login.emailLabel")}
                </label>
                <Input
                  id="email"
                  type="email"
                  leadingIcon="user"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("login.emailPlaceholder")}
                  disabled={sent}
                />
              </div>

              <Button
                type="submit"
                variant="primary"
                style={{ width: "100%" }}
                disabled={loading || sent}
              >
                {sent ? t("login.checkInbox") : loading ? t("login.sending") : t("login.sendLink")}
              </Button>

              {error && (
                <p
                  className="error"
                  style={{ marginTop: 12, whiteSpace: "pre-line", fontSize: 13 }}
                >
                  {error}
                </p>
              )}
            </form>
          )}
        </Card>
      </div>
    </main>
  );
}
